import { useRef } from 'react';
import { motion } from 'framer-motion';
import { useDragStore } from '../../../stores/dragStore';

const ONCALL_COLORS = [
  'bg-slate-500',
  'bg-slate-500',
  'bg-slate-500',
  'bg-slate-500',
];

export function Oncall() {
  const squareRefs = useRef<(HTMLDivElement | null)[]>([]);
  const { registerOncallSquarePosition, snappedSquares } = useDragStore();

  // Register square positions for drop detection
  const handleSquareRef = (index: number) => (el: HTMLDivElement | null) => {
    squareRefs.current[index] = el;
    if (el) {
      const rect = el.getBoundingClientRect();
      registerOncallSquarePosition(
        index,
        rect.left,
        rect.top,
        rect.width,
        rect.height,
      );
    }
  };

  // Check if snappedSquares matches the pattern [blue, green, green, red]
  const isTargetPattern =
    snappedSquares[0]?.includes('blue') &&
    snappedSquares[1]?.includes('green') &&
    snappedSquares[2]?.includes('green') &&
    snappedSquares[3]?.includes('red');

  if (isTargetPattern) {
    return (
      <motion.div
        className="relative h-full overflow-visible"
        initial={{ opacity: 0, y: 100 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, ease: 'easeOut' }}
      >
        {/* Blurred background text */}
        <div className="absolute inset-0 pointer-events-none blur-sm">
          <h1>Emergency contact procedures and escalation paths</h1>
          <p>On-call rotation schedule and coverage details</p>
          <p>Incident response protocols and communication channels</p>
          <p>Runbook references for common issues and troubleshooting</p>
          <p>Alert handling guidelines and response times</p>
          <p>Post-incident review process and documentation</p>
          <h2>On-call support resources and team contacts</h2>
          <p>Escalation procedures for critical issues</p>
          <h4>Maintenance windows and planned downtime procedures</h4>
          <h2>Status page updates and customer communication</h2>
          <p>Root cause analysis and incident tracking</p>
          <p>On-call handoff procedures and shift transitions</p>
        </div>
        {/* Content on top */}
        <div className="relative z-10 top-30 h-fit h-full">
          <p>
            This handbook is outdated. Just make sure your badge is activated.
            Also read last week eval, the password is loev? - Alex
          </p>
          <div className="relative w-64 min-h-80 border border-gray-300 mt-6 flex items-center justify-center">
            <span>badge</span>
            <span className="absolute top-2 left-2 text-sm font-semibold">
              L
            </span>
            <span className="absolute bottom-2 right-2 text-sm font-semibold">
              X
            </span>
            <span className="absolute bottom-2 left-2 text-sm font-semibold">
              ♥
            </span>
            <span className="absolute top-2 right-2 text-sm font-semibold">
              ?
            </span>
          </div>
        </div>
      </motion.div>
    );
  }

  return (
    <article className="prose">
      <div className="mt-8">
        <h2 className="text-lg font-semibold mb-4">laura birthday</h2>
        <div className="flex items-center justify-between px-4 md:px-0">
          {ONCALL_COLORS.map((color, index) => (
            <div key={color} className="flex flex-col items-center">
              <div
                ref={handleSquareRef(index)}
                className={`w-8 h-8 ${
                  snappedSquares[index]
                    ? snappedSquares[index]
                    : 'border border-black'
                } transition-all`}
              />
              <span className="text-lg mt-2">{index < 2 ? 'm' : 'd'}</span>
            </div>
          ))}
        </div>
      </div>
    </article>
  );
}
